import { Button, Stack, Typography } from "@mui/material";
import { statesMap } from "src/constants/usStates";
import AddIcon from "@mui/icons-material/Add";
import { useManageModal } from "src/hooks/useManageModal";
import { useMemo } from "react";
import { useGetProviderLicensesQuery } from "src/api/services/providersApi";
import { skipToken } from "@reduxjs/toolkit/query";
import CreateProviderLicensesModal from "src/components/Modals/CreateProviderLicensesModal";
import License from "../License";
import WhiteCard from "src/components/WhiteCard";

interface Props {
  providerId: number;
}
const Licenses = ({ providerId }: Props) => {
  const { data: licenses = [] } = useGetProviderLicensesQuery(
    providerId ?? skipToken
  );

  const [open, { handleClose, handleOpen }] = useManageModal();

  const states = useMemo(
    () => licenses.map((l) => statesMap[l.state_code]),
    [licenses]
  );

  const key = useMemo(() => states.join(","), [states]);

  return (
    <>
      <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
        <Stack gap={1}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2">PROVIDER LICENSES</Typography>
            <Button
              variant="text"
              sx={{ alignSelf: "start" }}
              onClick={handleOpen}
              startIcon={<AddIcon />}
            >
              Create
            </Button>
          </Stack>

          <Stack>
            {licenses.map((license) => (
              <License license={license} key={license.state_code} />
            ))}
          </Stack>
        </Stack>
      </WhiteCard>
      <CreateProviderLicensesModal
        key={key}
        open={open}
        onClose={handleClose}
        providerId={providerId}
        licenses={states}
      />
    </>
  );
};

export default Licenses;
